import React, { Component } from 'react';
import YantraForm from './YantraForm';
import NavBar from '../NavBar/NavBar';
import './YantraPage.css';

class YantraPage extends Component {
  render () {
    return (
      <div className="YantraPage">
        <NavBar />
        <YantraForm />
      </div>
    )
  }
}

export default YantraPage;



// WEBPACK FOOTER //
// ./src/components/YantraPage/YantraPage.js